import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Sidenav/sgds-sidenav-link";
import { register } from "../../utils/ce-registry";

register("sgds-sidenav-link", Component);

export default createComponent({
  react: React,
  tagName: "sgds-sidenav-link",
  elementClass: Component,
  events: {}
});
